// import Swiper JS
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'

let blockWideGallery = document.querySelectorAll(
  '.wp-block-acf-gallery-wide .swiper-container'
)

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay])

if (blockWideGallery) {
  blockWideGallery.forEach(wideGallery => {
    let currentGallerySlide = wideGallery.querySelector('.current-slide')
    let totalGallerySlides = wideGallery.querySelector('.total-slide')

    // init Swiper:
    let galleryWideCarousel = new Swiper(wideGallery, {
      loop: true,
      autoplay: {
        delay: 5000,
        pauseOnMouseEnter: false,
        disableOnInteraction: false,
        reverseDirection: false
      },
      slidesPerView: 1,
      stopOnLastSlide: false,

      // bullets
      pagination: {
        el: '.swiper-pagination'
      },

      // arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },

      runCallbacksOnInit: true,
      on: {
        init: function (el) {
          currentGallerySlide.innerHTML = el.activeIndex + 1
          totalGallerySlides.innerHTML = el.slides.length
        },
        slideChange: function (el) {
          currentGallerySlide.innerHTML = el.activeIndex + 1
          totalGallerySlides.innerHTML = el.slides.length
        }
      }
    })
  })
}
